import { burgerConfigMobile } from './Header.config.burger';
import ProjectLogo from '@media-platform/project-logo/dist/pets/pets_name.svg';
import RBSlot from '../Slot';
import type { IConfigPortalMenu, IPortalMenuSlotAPI, Menu, } from '@media-platform/portal-menu/src/types';
import { counterTrigger } from 'Src/tools/counters';
import { presetTooltip, presetAuth, } from '@media-platform/portal-menu/src/presets';
import { IPortalHeaderConfig } from './Header.types';
import IconPaw from '../../icons/animal-paw-inverted.svg';
import HeadlineTooltipButton from 'Src/components/HeadlineTooltipButton';
import HeadlineTooltipMenu from 'Src/components/HeadlineTooltipMenu';
const getPromoSlots = (): IPortalMenuSlotAPI[] => {
    const aliases = ['promoButton1', 'promoButton2'];
    return aliases.map((alias) => ({
        type: 'slot',
        children: <RBSlot alias={alias}/>,
    }));
};
export function portalHeaderConfig({ utm, projectName, showMobilePromo, search, menuLinks, }: IPortalHeaderConfig): IConfigPortalMenu {
    const searchConfig = {
        type: 'search',
        placeholder: 'Поиск по сайту',
        name: 'q',
        action: '/search/',
        inputProps: search && {
            defaultValue: search.query || '',
        },
        hiddenInputs: utm
            ? [
                {
                    name: 'utm_partner_id',
                    value: utm,
                },
            ]
            : undefined,
    };
    const privateConfig = {
        type: 'tooltip',
        trigger: 'hover',
        children: (<HeadlineTooltipButton>
        <IconPaw />
      </HeadlineTooltipButton>),
        content: <HeadlineTooltipMenu menuLinks={menuLinks}/>,
        popperOptions: { strategy: 'fixed' },
    };
    const authConfig = {
        project: 'pets',
        type: 'auth',
    };
    return {
        projectLogo: {
            logo: ProjectLogo,
            href: '/',
            title: projectName,
        },
        toolBarMobile: {
            menuItemOnClick: (_, props) => {
                const { counter } = props as Menu;
                if (counter && counter.desktop) {
                    counterTrigger('portalMenu', { id: counter.mobile });
                }
            },
            burger: {
                ...burgerConfigMobile(),
            },
            promo: showMobilePromo
                ? {
                    items: getPromoSlots(),
                }
                : undefined,
            right: {
                items: [privateConfig, searchConfig, authConfig],
            },
        },
        toolBarDesktop: {
            menuItemOnClick: (_, props) => {
                const { counter } = props as Menu;
                if (counter && counter.desktop) {
                    counterTrigger('portalMenu', { id: counter.desktop });
                }
            },
            promo: showMobilePromo
                ? {
                    items: getPromoSlots(),
                }
                : undefined,
            right: {
                items: [privateConfig, searchConfig, authConfig],
            },
        },
        presets: {
            ...presetTooltip(),
            ...presetAuth(),
        },
    };
}
